import { handleOtherActions, handleAddToClipboard, handleViewMap } from "../../../js/components/other-actions";
import { handleSaveEvent } from "../../../js/components/save-community";
import { resetCookie } from "../../../js/components/cookie-functions";
import { initQuickViewModal } from '../../../js/components/quick-view';
import { removeFloorplan } from "../../../js/api/saved-items";
import { openLeaseTerm } from '../../../js/components/lease-term';
import { showLeasingInfo } from "../../../js/components/other-actions";

// eslint-disable-next-line import/prefer-default-export
export const availableApartments = () => {
  const filters = document.querySelectorAll('.aa-filter');
  const scrollLeft = document.querySelector('[href="#left"]');
  const scrollRight = document.querySelector('[href="#right"]');
  const aptList = document.querySelectorAll('.available-apartments__body--apt');
  const closeOther = document.querySelectorAll('.other-actions-dropdown__header [href="#close"]');
  const save = document.querySelectorAll('.apt-fav');
  const copy = document.querySelectorAll('.add-clipboard');
  const reset = document.querySelector('.reset');
  const availableApartmentsSection = document.querySelector('section#available-apartments');
  const otherActions = document.querySelectorAll('.other');
  const leasingInfo = document.querySelectorAll('.open-leasing-info');

  const floorPlanIds = [];

  let scrollCount = 0;
  let maxScroll = aptList.length;
  let viewWidth = 1440;

  const initWidth = (e) => {
    if(screen.width < 1440) {
      viewWidth = screen.width;
    }

    maxScroll = maxScroll - Math.ceil(viewWidth / 304);
  }

  window.addEventListener('resize', () => {
    initWidth();
  }, true);

  initWidth();

  const showOtherActions = (e) => {
    e.preventDefault();
    const openActions = document.querySelectorAll(".available-apartments__body--apt.open");
    openActions.forEach((item) => {
      if(item != e.currentTarget) item.classList.remove('open');
    })
    const availableApartmentsBody = e.currentTarget && e.currentTarget.closest(".available-apartments__body--apt");
    if (availableApartmentsBody) {
      availableApartmentsBody.classList.toggle('open');
    }
    handleOtherActions(e);
  }

  if (otherActions) {
    otherActions.forEach((item) => {
      item.addEventListener('click', showOtherActions);
    });
  }

  const applyFilter = (type) => {
    aptList.forEach((item) => {
      item.style.transform = 'translateX(0)';
      if(type !== 'all'){
        item.classList.toggle('hide', item.getAttribute('data-filter') !== type);
      } else {
        item.classList.remove('hide');
      }
    })

    // RESET ANY SCROLLING
    if(scrollLeft) {
      scrollLeft.classList.add('disabled');
    }
    if(scrollRight) {
      scrollRight.classList.remove('disabled');
    }
    scrollCount = 0;
  }

  const handleFilter = (e) => {
    e.preventDefault();
    document.querySelector('.aa-filter.active').classList.remove('active');
    e.currentTarget.classList.add('active');
    const type = e.currentTarget.dataset.type;

    applyFilter(type);
  }

  filters.forEach((item) => {
    item.addEventListener('click', handleFilter);
  })

  const handleScrollRight = (e) => {
    if(scrollCount < maxScroll){
      scrollCount++;
      const scrollAmt = scrollCount * 304;
      aptList.forEach((item) => {
        item.style.transform = `translateX(-${scrollAmt}px)`;
      })
      scrollLeft.classList.remove('disabled');
      scrollRight.classList.toggle('disabled', scrollCount === maxScroll);
    }
  }

  const handleScrollLeft = (e) => {
    if(scrollCount > 0){
      scrollCount--;
      const scrollAmt = scrollCount * 304;
      aptList.forEach((item) => {
        item.style.transform = `translateX(-${scrollAmt}px)`;
      })
      scrollRight.classList.remove('disabled');
      scrollLeft.classList.toggle('disabled', scrollCount === 0);
    }
  }

  if(scrollLeft) {
    scrollLeft.addEventListener('click', handleScrollLeft);
  }

  if(scrollRight) {
    scrollRight.addEventListener('click', handleScrollRight);
  }

  const handleClose = (e) => {
    e.preventDefault();
    const openOther = document.querySelector('.other.open');
    const activeDropdown = document.querySelector('.other-actions-dropdown.active');
    openOther.append(activeDropdown);
    openOther.classList.remove('open');
    activeDropdown.classList.remove('active');
    document.querySelector('.other-overlay').classList.remove('active');
  }

  closeOther.forEach((item) => {
    item.addEventListener('click', handleClose);
  })

  save.forEach((item) => {
    if(item.classList.contains('saved')) floorPlanIds.push(item.getAttribute('data-id'));
    item.addEventListener('click', handleSaveEvent);
  })

  copy.forEach((item) => {
    item.addEventListener('click', handleAddToClipboard);
  })

  if(reset){
    reset.addEventListener('click', () => {
      resetCookie();
      console.log('Cookie reset');
    })
  }

  // const openQuickViewModal = (e) => {
  //   e.preventDefault();
  //   const { id } = e.currentTarget.dataset;
  //   if (id) {
  //     initQuickViewModal(id);
  //   }
  // };

  // const handleQuickViewModal = () => {
  //   const openQuickViewModalButton = document.querySelectorAll(
  //     ".open-quick-view-modal"
  //   );

  //   openViewMapModalButton.forEach(quickView => {
  //     quickView.addEventListener("click", handleViewMap);
  //   });
  // };

  const handleViewMapModal = () => {
    const openViewMapModalButton = document.querySelectorAll(
      ".open-view-map-modal"
    );

    openViewMapModalButton.forEach(quickView => {
      quickView.addEventListener("click", handleViewMap);
    });
  };

  leasingInfo.forEach((item) => {
    item.addEventListener("click", showLeasingInfo);
  });

  handleViewMapModal();

  const handleQueryParams = () => {
    const searchParams = new URLSearchParams(window.location.search);
    if (searchParams.has('unit_type')) {
      const unitTypeValue = searchParams.get('unit_type');
      const tab = availableApartmentsSection.querySelector(`li > p[data-type="${unitTypeValue}"].aa-filter`);
      if (tab) {
        document.querySelector('.aa-filter.active').classList.remove('active');
        tab.classList.add('active');
        applyFilter(unitTypeValue);
      }
    }
  }

  if (availableApartmentsSection) {
    const leaseTermsItems = availableApartmentsSection.querySelectorAll('.leasing-terms_list_item');
    leaseTermsItems.forEach((el) => {
      el.addEventListener('click', openLeaseTerm);
    });
    handleQueryParams();
  }

  // commented due to adding one listener twice
  // same listener is added in maa-communities controller
  // handleQuickViewModal();
}



// WEBPACK FOOTER //
// ./src/templates/components/available-apartments/available-apartments.js